<!-- HDI(盲埋孔) -->
<template>
  <BaseFormItem2
    :label="fields.label"
    :labelTips="fields.labelTips"
  >
    <BaseRadioGroup2 v-model="val" @change="handleEmit">
      <el-radio-button
        class="blind__radio"
        v-for="item in options"
        :key="item.value"
        :label="item.value"
        :disabled="item.disabled"
      >
        {{ item.label }}
        <span
          v-if="item.value == 1 && blayer == 4"
          class="blind__radio__tips"
        >快至7天</span>
      </el-radio-button>
    </BaseRadioGroup2>
  </BaseFormItem2>
</template>

<script>
import { getFR4Fields } from '@@/utils/getFields'

export default {
  props: {
    value: {
      type: Number,
      default: 0
    },
    // 是否是HDI板
    isHdi: {
      type: Boolean,
      default: false
    },
    // 板子层数
    blayer: {
      type: Number,
      default: 2
    },
    // 返回修改初始化参数时，参数不进行关联变更
    initPcbParamsChange: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      val: this.value
    }
  },
  computed: {
    fields() {
      return getFR4Fields('blind')
    },
    options() {
      const { value, isHdi, blayer, fields } = this
      let options = [...fields.options]
      // 最大阶数展示
      const maxBlindVal = (blayer - 2) / 2
      if (value > 3) {
        options.push({
          value: value,
          label: `${value} 阶`,
        })
      }

      return options.map(item => ({ ...item, disabled: (item.value > 1 && item.value > maxBlindVal) || (blayer == 2 && item.value == 1) || (isHdi && item.value === 0) }))
    }
  },
  watch: {
    value(newVal) {
      this.val = newVal
    },
    blayer(blayer) {
      // 板子层数对阶数的限制
      const maxBlindValMap = { 4: 1, 6: 2, 8: 3, 10: 4 }
      if (maxBlindValMap[blayer] && this.value > maxBlindValMap[blayer]) {
        this.changeVal(1)
      }
    }
  },
  methods: {
    handleEmit() {
      const val = this.val
      this.$emit('input', val)
      this.$emit('change', val)
    },
    changeVal(val) {
      if (this.initPcbParamsChange) return
      this.$topWarning.mergeFields(this.fields.label)
      this.val = val
      this.handleEmit()
    }
  }
}
</script>

<style lang="scss" scoped>
.blind__radio {
  position: relative;
  .blind__radio__tips {
    position: absolute;
    top: -9px;
    right: -6px;
    z-index: 999;
    // 字号用 12px 起步再整体缩放到 10px 的效果（规避浏览器最小字号限制），
    // padding/height/border-radius 按 12/10 放大，缩放后视觉尺寸与原来一致
    padding: 0 5px;
    height: 19px;
    line-height: 19px;
    font-size: 12px;
    transform: scale(0.8333);
    transform-origin: right top;
    color: #fff;
    white-space: nowrap;
    background-color: #e6a23c;
    border-radius: 5px;
  }
}
</style>